<template>
    <div class="contentbox selecttime">
      <div class="toptitle">
        <span class="return">
          <!--<router-link tag="span" :to="'/shoppingcart?id='+$route.query.id">&lt;</router-link>-->
          <span @click="$router.go(-1)">&lt;</span>
        </span>
        <span>選擇時間</span>
        <span @click="onsave" class="topimgbox rg">
          保存
        </span>
      </div>
      <div class="selecttimebox">
        <div v-if="baseInfo.delivery_time_show === '1'">
          <p>時間段 <Dot :bacolor="true" @ontime_type="ontime_type1" :state="time_type===1?true:false"></Dot></p>
          <p>{{time_type==2?'':timevalue}}</p>
        </div>
        <div v-if="baseInfo.delivery_time_point_show === '1'">
          <p>時間點 <Dot :bacolor="true" @ontime_type="ontime_type2" :state="time_type===2?true:false"></Dot></p>
          <p>{{time_type==1?'':timevalue}}</p>
        </div>
      </div>
      <Field label="日期" placeholder="請選擇日期" type="date" v-model="datevalue"></Field >
      <div class="timesilt">
        <Picker :slots="slots"
                :visibleItemCount="visibleItemCount"
                @change="onValuesChange"></Picker>
      </div>
    </div>
</template>

<script>
  import { MessageBox,Button,Picker,Field   } from 'mint-ui';
  import Dot from '../assembly/Dot/Dot'
  import ScrollPosition from '../assets/js/scroll-position'
  import {
    getUserInfo,
    baseInfo,
  } from '../assets/js/api'
    export default {
        name: "selecttime",
        data(){
          return{
            userinfo:{},
            slots: [],
            visibleItemCount:15,
            timevalue:'',
            time_type:this.$store.state.userdata.time_type===0 ? 1 : this.$store.state.userdata.time_type,
            datevalue:'',
            baseInfo:{}
          }
        },
        components:{
          Picker,
          Dot,
          Field
        },
        mounted(){
          let myDate = new Date();
          let defaultmyDate = myDate.getFullYear();
          defaultmyDate += '-'+(myDate.getMonth()+1);
          defaultmyDate += '-'+myDate.getDate();
          this.datevalue = this.$store.state.userdata.datevalue || defaultmyDate
          baseInfo().then((data)=>{
            this.baseInfo = data
          })
          setTimeout(()=>{
            ScrollPosition.goTop.call(this);
          })
          this.gettime()
        },
        methods:{
          onValuesChange(picker, values) {
            if (values[0] > values[1]) {
              picker.setSlotValue(1, values[0]);
            }
            this.timevalue = values[0]
          },
          onsave(){
            let obj = {
              time:this.timevalue,
              time_type:this.time_type,
              datevalue:this.datevalue,
            }
            this.$store.commit('setDeliverytime',obj)
            // this.$router.push({ path: '/shoppingcart?id='+this.$route.query.id});
            this.$router.go(-1)
          },
          ontime_type1(){
            this.time_type = 1
            this.gettime()
          },
          ontime_type2(){
            this.time_type = 2
            this.gettime()
          },
          gettime(){
            getUserInfo(this.time_type).then((data)=>{
              let arr = data.userinfo.delivery_time
              this.slots = []
              this.slots.push({
                flex: 1,
                defaultIndex:Number.parseInt(arr.length/2),
                // value:Number.parseInt(arr.length/2),
                values: arr,
                className: 'slot1',
                textAlign: 'center',
              })
              this.timevalue = this.$store.state.userdata.Deliverytime || arr[Number.parseInt(arr.length/2)]
            })
          }
        },
        computed:{
        }
    }
</script>

<style lang="less">
  @import "../assets/less/base";

  .contentbox.selecttime{
    background-color: #fff;
    width: 100%;
    .toptitle{
      position: fixed;
      z-index: 1;
      width: 90%;
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      /*position: relative;*/
      display: flex;
      justify-content: space-between;
      padding: 0 5%;
      .return{
        font-size: 40px;
        /*position: absolute;*/
        left: 0.2rem;
        cursor: pointer;
      }
      .topimgbox{
        /*position: absolute;*/
        left: 87%;
        cursor: pointer;
      }
    }
    .selecttimebox{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 0.2rem;
      margin-top: 52px;
      >div{
        width: 30%;
        p{
          text-align: center;
          margin-top: 0.15rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.3rem;
          height: 22px;
          span{
            margin-left: 0.2rem;
          }
        }
      }
    }
    .timesilt{
      border-top: 2px solid #f2f2f2;
      .picker-item{
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/selecttime.vue